import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import axios from "axios";
import {
  Mic, MicOff, Send, Volume2, VolumeX, Bot, MessageSquare, ListChecks,
  FileText, Image as ImageIcon, Code2, Calendar as CalIcon, Sparkles,
  Settings2, Play, Square, Trash2, Plus, Loader2, Wand2, Download,
  Wifi, Cpu, Activity, ShieldCheck, FolderPlus, FolderOpen, File as FileIcon,
  AlertTriangle, CheckCircle2, Bug, Package,
} from "lucide-react";
import { Toaster, toast } from "sonner";
import "@/index.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LANGS = [
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "en", label: "EN", name: "English" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "uk", label: "UK", name: "Українська" },
];

const VOICES = ["alloy", "echo", "fable", "onyx", "nova", "shimmer", "ash", "coral", "sage"];

const T = {
  tr: {
    assistant: "Asistan", tasks: "Görevler", reports: "Raporlar",
    imageStudio: "Görsel Stüdyo", code: "Kod", calendar: "Takvim",
    voicePacks: "Ses Paketleri", settings: "Ayarlar",
    placeholder: "ENGEREK'e bir şey söyle veya yaz...", send: "Gönder", listening: "Dinliyor...",
    speak: "Konuş", stopSpeak: "Sustur", newTask: "Yeni Görev",
    generateReport: "Rapor Üret", generatePlan: "Plan Üret", generateCode: "Kod Üret",
    topic: "Konu", generate: "Üret", generating: "Üretiliyor...", generateImage: "Görsel Üret",
    prompt: "Prompt", editImage: "Görseli Düzenle", uploadImage: "Görsel Yükle",
    gallery: "Galeri", clear: "Temizle", download: "İndir", filters: "Filtreler",
    voice: "Ses", speed: "Hız", model: "Model", testVoice: "Test",
    status: "SİSTEM OPERASYONEL", online: "ÇEVRİMİÇİ", secure: "GÜVENLİ",
    title: "GÖREV BAŞLIĞI", desc: "AÇIKLAMA", priority: "ÖNCELİK",
    low: "Düşük", medium: "Orta", high: "Yüksek",
    done: "Tamam", inProgress: "Sürüyor", pending: "Bekliyor",
    reset: "Sıfırla", brightness: "Parlaklık", contrast: "Kontrast",
    saturate: "Doygunluk", blur: "Bulanık", grayscale: "Gri", invert: "Ters",
    hero: "ENGEREK AL", subhero: "TAKTİK YAPAY ZEKA ASİSTANI",
    studio: "Stüdyo (Visual Studio)", newProject: "Yeni Proje", template: "Şablon",
    projectName: "Proje Adı", openProject: "Aç", downloadZip: "ZIP İndir",
    analyzeFix: "Analiz Et & Düzelt", autoFix: "Otomatik Düzelt",
    noProject: "Proje seçili değil. Yeni bir proje oluşturun veya listeden seçin.",
    diagnostics: "Tanı", allClean: "Hata bulunamadı — kod temiz.",
    createProject: "Projeyi Oluştur", saveFile: "Kaydet",
  },
  en: {
    assistant: "Assistant", tasks: "Tasks", reports: "Reports",
    imageStudio: "Image Studio", code: "Code", calendar: "Calendar",
    voicePacks: "Voice Packs", settings: "Settings",
    placeholder: "Say or type something to ENGEREK...", send: "Send", listening: "Listening...",
    speak: "Speak", stopSpeak: "Mute", newTask: "New Task",
    generateReport: "Generate Report", generatePlan: "Generate Plan", generateCode: "Generate Code",
    topic: "Topic", generate: "Generate", generating: "Generating...", generateImage: "Generate Image",
    prompt: "Prompt", editImage: "Edit Image", uploadImage: "Upload Image",
    gallery: "Gallery", clear: "Clear", download: "Download", filters: "Filters",
    voice: "Voice", speed: "Speed", model: "Model", testVoice: "Test",
    status: "SYSTEM OPERATIONAL", online: "ONLINE", secure: "SECURE",
    title: "TASK TITLE", desc: "DESCRIPTION", priority: "PRIORITY",
    low: "Low", medium: "Medium", high: "High",
    done: "Done", inProgress: "In Progress", pending: "Pending",
    reset: "Reset", brightness: "Brightness", contrast: "Contrast",
    saturate: "Saturate", blur: "Blur", grayscale: "Grayscale", invert: "Invert",
    hero: "ENGEREK AL", subhero: "TACTICAL AI ASSISTANT",
    studio: "Studio (Visual Studio)", newProject: "New Project", template: "Template",
    projectName: "Project Name", openProject: "Open", downloadZip: "Download ZIP",
    analyzeFix: "Analyze & Fix", autoFix: "Auto-Fix",
    noProject: "No project selected. Create a new one or pick from the list.",
    diagnostics: "Diagnostics", allClean: "No issues found — code is clean.",
    createProject: "Create Project", saveFile: "Save",
  },
  ru: {
    assistant: "Ассистент", tasks: "Задачи", reports: "Отчёты",
    imageStudio: "Студия", code: "Код", calendar: "Календарь",
    voicePacks: "Голоса", settings: "Настройки",
    placeholder: "Скажите или напишите ENGEREK...", send: "Отпр.", listening: "Слушаю...",
    speak: "Голос", stopSpeak: "Тихо", newTask: "Задача",
    generateReport: "Отчёт", generatePlan: "План", generateCode: "Код",
    topic: "Тема", generate: "Создать", generating: "Создание...", generateImage: "Создать",
    prompt: "Промпт", editImage: "Редакт.", uploadImage: "Загрузить",
    gallery: "Галерея", clear: "Очистить", download: "Скачать", filters: "Фильтры",
    voice: "Голос", speed: "Скорость", model: "Модель", testVoice: "Тест",
    status: "СИСТЕМА В СЕТИ", online: "ONLINE", secure: "ЗАЩИЩЕНО",
    title: "НАЗВАНИЕ", desc: "ОПИСАНИЕ", priority: "ПРИОРИТЕТ",
    low: "Низк.", medium: "Средн.", high: "Высок.",
    done: "Готово", inProgress: "В процессе", pending: "Ожидает",
    reset: "Сброс", brightness: "Яркость", contrast: "Контраст",
    saturate: "Насыщ.", blur: "Размытие", grayscale: "Ч/Б", invert: "Инверсия",
    hero: "ENGEREK AL", subhero: "ТАКТИЧЕСКИЙ ИИ",
    studio: "Студия (Visual Studio)", newProject: "Новый проект", template: "Шаблон",
    projectName: "Имя проекта", openProject: "Открыть", downloadZip: "Скачать ZIP",
    analyzeFix: "Анализ и правка", autoFix: "Авто-правка",
    noProject: "Проект не выбран. Создайте новый или выберите из списка.",
    diagnostics: "Диагностика", allClean: "Ошибок нет — код чист.",
    createProject: "Создать проект", saveFile: "Сохранить",
  },
  uk: {
    assistant: "Асистент", tasks: "Задачі", reports: "Звіти",
    imageStudio: "Студія", code: "Код", calendar: "Календар",
    voicePacks: "Голоси", settings: "Налашт.",
    placeholder: "Скажіть або напишіть ENGEREK...", send: "Надіс.", listening: "Слухаю...",
    speak: "Голос", stopSpeak: "Тихо", newTask: "Задача",
    generateReport: "Звіт", generatePlan: "План", generateCode: "Код",
    topic: "Тема", generate: "Створити", generating: "Створення...", generateImage: "Створити",
    prompt: "Промпт", editImage: "Редаг.", uploadImage: "Завант.",
    gallery: "Галерея", clear: "Очистити", download: "Завант.", filters: "Фільтри",
    voice: "Голос", speed: "Швидк.", model: "Модель", testVoice: "Тест",
    status: "СИСТЕМА В МЕРЕЖІ", online: "ONLINE", secure: "ЗАХИЩЕНО",
    title: "НАЗВА", desc: "ОПИС", priority: "ПРІОРИТЕТ",
    low: "Низьк.", medium: "Серед.", high: "Висок.",
    done: "Готово", inProgress: "В роботі", pending: "Очікує",
    reset: "Скид.", brightness: "Яскр.", contrast: "Контр.",
    saturate: "Насич.", blur: "Розмиття", grayscale: "Ч/Б", invert: "Інверсія",
    hero: "ENGEREK AL", subhero: "ТАКТИЧНИЙ ШІ",
    studio: "Студія (Visual Studio)", newProject: "Новий проект", template: "Шаблон",
    projectName: "Назва проекту", openProject: "Відкрити", downloadZip: "Завант. ZIP",
    analyzeFix: "Аналіз і правка", autoFix: "Авто-правка",
    noProject: "Проект не обрано. Створіть новий або оберіть зі списку.",
    diagnostics: "Діагностика", allClean: "Помилок нема — код чистий.",
    createProject: "Створити проект", saveFile: "Зберегти",
  },
};

// -------- Tiny markdown renderer (headers, bold, code, lists) --------
function renderMarkdown(md) {
  if (!md) return "";
  const esc = (s) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  let out = esc(md);
  out = out.replace(/```([\s\S]*?)```/g, (_, c) => `<pre><code>${c.replace(/^\n/, "")}</code></pre>`);
  out = out.replace(/`([^`]+)`/g, "<code>$1</code>");
  out = out.replace(/^### (.+)$/gm, "<h3>$1</h3>");
  out = out.replace(/^## (.+)$/gm, "<h2>$1</h2>");
  out = out.replace(/^# (.+)$/gm, "<h1>$1</h1>");
  out = out.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  out = out.replace(/^\s*[-*]\s+(.+)$/gm, "<li>$1</li>");
  out = out.replace(/(<li>[\s\S]+?<\/li>)/g, "<ul>$1</ul>");
  out = out.split(/\n{2,}/).map((p) =>
    p.startsWith("<h") || p.startsWith("<ul") || p.startsWith("<pre") ? p : `<p>${p.replace(/\n/g, "<br/>")}</p>`
  ).join("");
  return out;
}

// ===== Header =====
function TopBar({ lang, setLang, connected }) {
  const t = T[lang];
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(i);
  }, []);
  return (
    <div className="hud px-5 py-2 flex items-center justify-between border-b border-red-900/40 relative z-10" data-testid="top-bar">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <div className="w-2.5 h-2.5 rounded-full bg-red-500 orb-idle" />
          <span className="font-orbitron font-black text-xl tracking-wider text-white">ENGEREK</span>
          <span className="font-orbitron text-xs tracking-[0.35em] text-red-400/80">AL // v1.0</span>
        </div>
        <div className="hidden md:flex items-center gap-2 text-xs font-mono-hud text-red-300/80">
          <ShieldCheck size={13} /> {t.secure}
          <span className="mx-1 opacity-40">|</span>
          <Wifi size={13} className={connected ? "text-red-400" : "text-red-800"} />
          <span>{t.online}</span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="font-mono-hud text-red-300/90 text-sm tabular-nums tracking-widest" data-testid="hud-clock">
          {now.toLocaleTimeString([], { hour12: false })}
        </div>
        <div className="flex border border-red-900/40">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => setLang(l.code)}
              data-testid={`lang-${l.code}`}
              className={`px-2.5 py-1 text-xs font-orbitron tracking-widest transition-colors duration-200 ${
                lang === l.code
                  ? "bg-red-700/80 text-white"
                  : "text-red-300/80 hover:bg-red-900/30"
              }`}
              title={l.name}
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ===== Sidebar =====
function Sidebar({ tab, setTab, lang }) {
  const t = T[lang];
  const items = [
    { id: "assistant", icon: Bot, label: t.assistant },
    { id: "tasks", icon: ListChecks, label: t.tasks },
    { id: "reports", icon: FileText, label: t.reports },
    { id: "image", icon: ImageIcon, label: t.imageStudio },
    { id: "code", icon: Code2, label: t.code },
    { id: "studio", icon: FolderOpen, label: t.studio },
    { id: "calendar", icon: CalIcon, label: t.calendar },
    { id: "voice", icon: Volume2, label: t.voicePacks },
    { id: "settings", icon: Settings2, label: t.settings },
  ];
  return (
    <aside className="w-60 hud border-r border-red-900/40 flex flex-col relative" data-testid="sidebar">
      <div className="px-4 py-4 border-b border-red-900/40">
        <div className="font-orbitron text-[10px] tracking-[0.35em] text-red-500/80">SYSTEM</div>
        <div className="font-rajdhani font-bold text-lg text-white tracking-wide">CONTROL DECK</div>
      </div>
      <nav className="flex-1 py-3">
        {items.map((it) => (
          <div
            key={it.id}
            data-testid={`nav-${it.id}`}
            onClick={() => setTab(it.id)}
            className={`sidebar-item ${tab === it.id ? "active" : ""}`}
          >
            <it.icon size={16} />
            <span>{it.label}</span>
          </div>
        ))}
      </nav>
      <div className="p-3 border-t border-red-900/40 space-y-1 text-[10px] font-mono-hud text-red-300/70">
        <div className="flex items-center justify-between"><span><Cpu size={10} className="inline"/> CPU</span><span>32%</span></div>
        <div className="flex items-center justify-between"><span><Activity size={10} className="inline"/> LINK</span><span className="text-red-400">STABLE</span></div>
      </div>
    </aside>
  );
}

// ===== Voice Orb =====
function VoiceOrb({ state }) {
  const cls = state === "listening" ? "orb-listening" : state === "speaking" ? "orb-speaking" : "orb-idle";
  return (
    <div className="relative w-52 h-52 flex items-center justify-center" data-testid="voice-orb">
      <div className="absolute inset-0 rings" />
      <div className="absolute inset-[-40%] radar" />
      <div className={`orb ${cls} w-40 h-40 rounded-full`} />
      <div className="absolute font-orbitron text-[10px] tracking-[0.4em] text-red-100/90 mt-52">
        {state.toUpperCase()}
      </div>
    </div>
  );
}

// ===== Waveform =====
function Waveform({ active }) {
  return (
    <div className="flex items-end h-6" data-testid="waveform">
      {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
        <span
          key={i}
          className="wave-bar"
          style={{
            animationDelay: `${i * 0.09}s`,
            opacity: active ? 1 : 0.25,
            height: active ? undefined : "4px",
          }}
        />
      ))}
    </div>
  );
}

// ===== Assistant Tab =====
function AssistantTab({ lang, voice, ttsEnabled, setOrbState }) {
  const t = T[lang];
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [streaming, setStreaming] = useState(false);
  const [recording, setRecording] = useState(false);
  const sessionId = useMemo(
    () => localStorage.getItem("engerek-session") || (() => {
      const s = "sess-" + Math.random().toString(36).slice(2, 10);
      localStorage.setItem("engerek-session", s);
      return s;
    })(),
    []
  );
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);
  const bottomRef = useRef(null);
  const audioElRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/chat/history/${sessionId}`).then((r) => setMessages(r.data || [])).catch(() => {});
  }, [sessionId]);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const speak = useCallback(async (text) => {
    if (!ttsEnabled || !text) return;
    try {
      setOrbState("speaking");
      const r = await axios.post(`${API}/voice/tts`, { text, voice }, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      if (audioElRef.current) { audioElRef.current.pause(); audioElRef.current.src = ""; }
      const a = new Audio(url);
      audioElRef.current = a;
      a.onended = () => setOrbState("idle");
      a.onerror = () => setOrbState("idle");
      await a.play();
    } catch (e) { setOrbState("idle"); }
  }, [voice, ttsEnabled, setOrbState]);

  const send = useCallback(async (text) => {
    const msg = (text || input).trim();
    if (!msg || streaming) return;
    setInput("");
    setStreaming(true);
    setOrbState("listening");
    const userMsg = { id: "u-" + Date.now(), role: "user", content: msg };
    const asstMsg = { id: "a-" + Date.now(), role: "assistant", content: "" };
    setMessages((p) => [...p, userMsg, asstMsg]);
    try {
      const resp = await fetch(`${API}/chat/stream`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, message: msg, language: lang }),
      });
      const reader = resp.body.getReader();
      const dec = new TextDecoder();
      let full = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = dec.decode(value, { stream: true });
        full += chunk;
        setMessages((p) => {
          const c = [...p];
          c[c.length - 1] = { ...c[c.length - 1], content: full };
          return c;
        });
      }
      setStreaming(false);
      setOrbState("idle");
      if (full) await speak(full);
    } catch (e) {
      setStreaming(false); setOrbState("idle");
      toast.error("ENGEREK offline: " + e.message);
    }
  }, [input, sessionId, lang, streaming, setOrbState, speak]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      chunksRef.current = [];
      rec.ondataavailable = (e) => chunksRef.current.push(e.data);
      rec.onstop = async () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        stream.getTracks().forEach((tr) => tr.stop());
        const fd = new FormData();
        fd.append("audio", blob, "voice.webm");
        fd.append("language", lang);
        try {
          const r = await axios.post(`${API}/voice/stt`, fd);
          if (r.data.text) send(r.data.text);
          else toast.error("STT boş yanıt");
        } catch (err) { toast.error("STT hata: " + err.message); }
      };
      mediaRef.current = rec;
      rec.start();
      setRecording(true);
      setOrbState("listening");
    } catch (e) { toast.error("Mikrofon reddedildi"); }
  };
  const stopRecording = () => {
    if (mediaRef.current && recording) {
      mediaRef.current.stop();
      setRecording(false);
      setOrbState("idle");
    }
  };

  const clearChat = async () => {
    await axios.delete(`${API}/chat/history/${sessionId}`);
    setMessages([]);
  };

  return (
    <div className="h-full flex flex-col lg:flex-row gap-4 p-4">
      <div className="lg:w-96 flex flex-col items-center justify-center gap-6 hud p-6 relative">
        <div className="font-orbitron text-[10px] tracking-[0.4em] text-red-400 self-start">CORE INTERFACE</div>
        <VoiceOrb state={recording ? "listening" : streaming ? "speaking" : "idle"} />
        <div className="flex flex-col items-center gap-2 mt-6">
          <div className="font-orbitron text-2xl font-black tracking-widest text-white">{t.hero}</div>
          <div className="font-rajdhani text-xs tracking-[0.3em] text-red-400">{t.subhero}</div>
          <Waveform active={recording || streaming} />
        </div>
        <div className="flex gap-2 mt-2">
          {!recording ? (
            <button className="btn-hud flex items-center gap-2" onClick={startRecording} data-testid="mic-start-btn">
              <Mic size={14} /> {t.speak}
            </button>
          ) : (
            <button className="btn-hud flex items-center gap-2" onClick={stopRecording} data-testid="mic-stop-btn">
              <Square size={14} /> Stop
            </button>
          )}
          <button className="btn-ghost flex items-center gap-2" onClick={clearChat} data-testid="chat-clear-btn">
            <Trash2 size={14} /> {t.clear}
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col hud p-4 relative">
        <div className="font-orbitron text-[10px] tracking-[0.4em] text-red-400 mb-2">COMM CHANNEL</div>
        <div className="flex-1 overflow-y-auto space-y-3 pr-1" data-testid="chat-messages">
          {messages.length === 0 && (
            <div className="text-red-300/60 font-chakra text-sm px-2 py-6 text-center border border-dashed border-red-900/40">
              [ ENGEREK bekleme modunda. Bir komut ver. ]
            </div>
          )}
          {messages.map((m) => (
            <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] px-3 py-2 ${m.role === "user" ? "chat-bubble-user" : "chat-bubble-ai"}`}>
                <div className="font-orbitron text-[9px] tracking-[0.3em] opacity-70 mb-1">
                  {m.role === "user" ? "OPERATOR" : "ENGEREK"}
                </div>
                <div
                  className="markdown-body text-sm leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: renderMarkdown(m.content || "…") }}
                />
              </div>
            </div>
          ))}
          <div ref={bottomRef} />
        </div>
        <div className="mt-3 flex gap-2">
          <input
            className="input-hud flex-1"
            placeholder={t.placeholder}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && send()}
            data-testid="chat-input"
          />
          <button className="btn-hud flex items-center gap-2" onClick={() => send()} disabled={streaming} data-testid="chat-send-btn">
            {streaming ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} {t.send}
          </button>
        </div>
      </div>
    </div>
  );
}

// ===== Tasks Tab =====
function TasksTab({ lang }) {
  const t = T[lang];
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [priority, setPriority] = useState("medium");
  const load = () => axios.get(`${API}/tasks`).then((r) => setTasks(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!title.trim()) return;
    await axios.post(`${API}/tasks`, { title, description: desc, priority });
    setTitle(""); setDesc(""); load();
    toast.success("Task locked in");
  };
  const cycle = async (id, cur) => {
    const nx = cur === "pending" ? "in_progress" : cur === "in_progress" ? "done" : "pending";
    await axios.patch(`${API}/tasks/${id}`, { status: nx }); load();
  };
  const remove = async (id) => { await axios.delete(`${API}/tasks/${id}`); load(); };

  const badge = (s) =>
    s === "done" ? "bg-red-900/60 text-red-100" : s === "in_progress" ? "bg-red-700 text-white" : "bg-red-950 text-red-300";
  const label = (s) => s === "done" ? t.done : s === "in_progress" ? t.inProgress : t.pending;

  return (
    <div className="p-4 grid lg:grid-cols-3 gap-4 h-full overflow-hidden">
      <div className="hud p-4 space-y-3">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// {t.newTask}</div>
        <input className="input-hud w-full" placeholder={t.title} value={title} onChange={(e) => setTitle(e.target.value)} data-testid="task-title" />
        <textarea className="input-hud w-full h-24 resize-none" placeholder={t.desc} value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="task-desc" />
        <div className="flex gap-2">
          {["low", "medium", "high"].map((p) => (
            <button key={p} onClick={() => setPriority(p)}
              className={`btn-ghost flex-1 ${priority === p ? "bg-red-800/40 text-white" : ""}`}
              data-testid={`task-priority-${p}`}>
              {p === "low" ? t.low : p === "medium" ? t.medium : t.high}
            </button>
          ))}
        </div>
        <button className="btn-hud w-full flex items-center justify-center gap-2" onClick={create} data-testid="task-create-btn">
          <Plus size={14} /> {t.newTask}
        </button>
      </div>
      <div className="lg:col-span-2 hud p-4 overflow-y-auto">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400 mb-3">// TASK QUEUE</div>
        <div className="space-y-2" data-testid="task-list">
          {tasks.length === 0 && <div className="text-red-300/60 text-sm">// EMPTY //</div>}
          {tasks.map((tk) => (
            <div key={tk.id} className="border border-red-900/30 p-3 flex items-start justify-between gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] font-orbitron px-2 py-0.5 ${badge(tk.status)}`}>{label(tk.status)}</span>
                  <span className="text-[10px] font-mono-hud text-red-400/70 uppercase">{tk.priority}</span>
                </div>
                <div className="font-rajdhani text-lg text-white mt-1">{tk.title}</div>
                {tk.description && <div className="text-red-200/70 text-sm mt-1 whitespace-pre-wrap">{tk.description}</div>}
              </div>
              <div className="flex gap-1">
                <button className="btn-ghost" onClick={() => cycle(tk.id, tk.status)} data-testid={`task-cycle-${tk.id}`}>
                  <Play size={12} />
                </button>
                <button className="btn-ghost" onClick={() => remove(tk.id)} data-testid={`task-del-${tk.id}`}>
                  <Trash2 size={12} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ===== Reports Tab =====
function ReportsTab({ lang, kindDefault = "report" }) {
  const t = T[lang];
  const [topic, setTopic] = useState("");
  const [kind, setKind] = useState(kindDefault);
  const [busy, setBusy] = useState(false);
  const [reports, setReports] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = () => axios.get(`${API}/reports`).then((r) => setReports(r.data));
  useEffect(() => { load(); }, []);

  const gen = async () => {
    if (!topic.trim()) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/reports/generate`, { topic, language: lang, kind });
      await load();
      setSelected(r.data);
      setTopic("");
      toast.success("Report ready");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const del = async (id) => { await axios.delete(`${API}/reports/${id}`); if (selected?.id === id) setSelected(null); load(); };

  const download = (r) => {
    const blob = new Blob([`# ${r.title}\n\n${r.content}`], { type: "text/markdown" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `${r.title.replace(/\s+/g, "_")}.md`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-4 grid lg:grid-cols-3 gap-4 h-full overflow-hidden">
      <div className="hud p-4 space-y-3">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// GENERATOR</div>
        <div className="flex gap-1">
          {[{k:"report",l:t.generateReport},{k:"plan",l:t.generatePlan},{k:"code",l:t.generateCode}].map(({k,l}) => (
            <button key={k} className={`btn-ghost flex-1 text-[10px] ${kind===k?"bg-red-800/40 text-white":""}`} onClick={() => setKind(k)} data-testid={`report-kind-${k}`}>
              {l}
            </button>
          ))}
        </div>
        <textarea className="input-hud w-full h-32 resize-none" placeholder={t.topic} value={topic} onChange={(e) => setTopic(e.target.value)} data-testid="report-topic" />
        <button className="btn-hud w-full flex items-center justify-center gap-2" onClick={gen} disabled={busy} data-testid="report-generate-btn">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Wand2 size={14} />} {busy ? t.generating : t.generate}
        </button>
        <div className="pt-3 border-t border-red-900/30 space-y-1 max-h-64 overflow-y-auto" data-testid="report-list">
          {reports.map((r) => (
            <div key={r.id} className={`p-2 border cursor-pointer transition-colors duration-200 ${selected?.id===r.id?"border-red-500 bg-red-900/20":"border-red-900/30 hover:bg-red-900/10"}`} onClick={() => setSelected(r)}>
              <div className="text-[10px] font-mono-hud text-red-400/70 uppercase">{r.kind} · {r.language}</div>
              <div className="font-rajdhani text-white text-sm truncate">{r.title}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-2 hud p-4 overflow-y-auto">
        <div className="flex items-center justify-between mb-3">
          <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// {selected ? selected.title : "PREVIEW"}</div>
          {selected && (
            <div className="flex gap-2">
              <button className="btn-ghost flex items-center gap-1" onClick={() => download(selected)} data-testid="report-download">
                <Download size={12} /> {t.download}
              </button>
              <button className="btn-ghost flex items-center gap-1" onClick={() => del(selected.id)} data-testid="report-delete">
                <Trash2 size={12} />
              </button>
            </div>
          )}
        </div>
        {selected ? (
          <div className="markdown-body text-sm text-red-100 leading-relaxed"
               dangerouslySetInnerHTML={{ __html: renderMarkdown(selected.content) }} />
        ) : (
          <div className="text-red-300/50 text-sm">// Select or generate a document //</div>
        )}
      </div>
    </div>
  );
}

// ===== Image Studio =====
function ImageTab({ lang }) {
  const t = T[lang];
  const [prompt, setPrompt] = useState("");
  const [busy, setBusy] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [current, setCurrent] = useState(null);
  const [file, setFile] = useState(null);
  const [filters, setFilters] = useState({ brightness: 100, contrast: 100, saturate: 100, blur: 0, grayscale: 0, invert: 0 });
  const load = () => axios.get(`${API}/image/gallery`).then((r) => setGallery(r.data));
  useEffect(() => { load(); }, []);

  const gen = async () => {
    if (!prompt.trim()) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/image/generate`, { prompt });
      setCurrent(r.data); await load(); setPrompt("");
      toast.success("Image generated");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const edit = async () => {
    if (!file || !prompt.trim()) { toast.error("Prompt + image needed"); return; }
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("prompt", prompt); fd.append("image", file);
      const r = await axios.post(`${API}/image/edit`, fd);
      setCurrent(r.data); await load(); setPrompt(""); setFile(null);
      toast.success("Image edited");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const filterStr = `brightness(${filters.brightness}%) contrast(${filters.contrast}%) saturate(${filters.saturate}%) blur(${filters.blur}px) grayscale(${filters.grayscale}%) invert(${filters.invert}%)`;

  const downloadFiltered = async () => {
    if (!current) return;
    const img = new Image(); img.crossOrigin = "anonymous"; img.src = current.data_url;
    await new Promise((res) => (img.onload = res));
    const cv = document.createElement("canvas");
    cv.width = img.naturalWidth; cv.height = img.naturalHeight;
    const ctx = cv.getContext("2d");
    ctx.filter = filterStr; ctx.drawImage(img, 0, 0);
    const a = document.createElement("a");
    a.href = cv.toDataURL("image/png"); a.download = "engerek-image.png"; a.click();
  };

  return (
    <div className="p-4 grid lg:grid-cols-3 gap-4 h-full overflow-hidden">
      <div className="hud p-4 space-y-3 overflow-y-auto">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// {t.imageStudio}</div>
        <textarea className="input-hud w-full h-24 resize-none" placeholder={t.prompt} value={prompt} onChange={(e) => setPrompt(e.target.value)} data-testid="image-prompt" />
        <div className="flex gap-2">
          <button className="btn-hud flex-1 flex items-center justify-center gap-2" onClick={gen} disabled={busy} data-testid="image-gen-btn">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} {t.generateImage}
          </button>
        </div>
        <div className="pt-2 border-t border-red-900/30 space-y-2">
          <label className="btn-ghost w-full flex items-center justify-center gap-2 cursor-pointer">
            <ImageIcon size={12} /> {t.uploadImage}
            <input type="file" accept="image/*" className="hidden" onChange={(e) => setFile(e.target.files?.[0])} data-testid="image-upload" />
          </label>
          {file && <div className="text-xs font-mono-hud text-red-300/70 truncate">{file.name}</div>}
          <button className="btn-hud w-full flex items-center justify-center gap-2" onClick={edit} disabled={busy || !file} data-testid="image-edit-btn">
            <Wand2 size={14} /> {t.editImage}
          </button>
        </div>
        <div className="pt-3 border-t border-red-900/30">
          <div className="font-orbitron text-[10px] tracking-[0.3em] text-red-400 mb-2">// {t.filters}</div>
          {[
            ["brightness", t.brightness, 0, 200], ["contrast", t.contrast, 0, 200],
            ["saturate", t.saturate, 0, 200], ["blur", t.blur, 0, 10],
            ["grayscale", t.grayscale, 0, 100], ["invert", t.invert, 0, 100],
          ].map(([k, l, mn, mx]) => (
            <div key={k} className="text-xs mb-1">
              <div className="flex justify-between text-red-300/70"><span>{l}</span><span>{filters[k]}</span></div>
              <input type="range" min={mn} max={mx} value={filters[k]} onChange={(e) => setFilters((f) => ({ ...f, [k]: +e.target.value }))} className="w-full accent-red-600" data-testid={`filter-${k}`}/>
            </div>
          ))}
          <div className="flex gap-2 mt-2">
            <button className="btn-ghost flex-1 text-[10px]" onClick={() => setFilters({ brightness: 100, contrast: 100, saturate: 100, blur: 0, grayscale: 0, invert: 0 })} data-testid="filter-reset">
              {t.reset}
            </button>
            <button className="btn-hud flex-1 flex items-center justify-center gap-1 text-[10px]" onClick={downloadFiltered} disabled={!current} data-testid="image-download">
              <Download size={12} /> {t.download}
            </button>
          </div>
        </div>
      </div>
      <div className="lg:col-span-2 hud p-4 overflow-y-auto">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400 mb-3">// PREVIEW</div>
        {current ? (
          <div className="mb-4 border border-red-900/30 grid-bg p-2">
            <img src={current.data_url} alt="gen" style={{ filter: filterStr }} className="w-full max-h-[420px] object-contain" data-testid="image-preview" />
          </div>
        ) : (
          <div className="text-red-300/50 text-sm mb-4">// No image loaded //</div>
        )}
        <div className="font-orbitron text-[10px] tracking-[0.3em] text-red-400 mb-2">// {t.gallery}</div>
        <div className="grid grid-cols-3 md:grid-cols-4 gap-2" data-testid="image-gallery">
          {gallery.map((g) => (
            <div key={g.id} onClick={() => { setCurrent(g); setFilters({ brightness: 100, contrast: 100, saturate: 100, blur: 0, grayscale: 0, invert: 0 }); }}
              className="cursor-pointer border border-red-900/30 hover:border-red-500 transition-colors duration-200">
              <img src={g.data_url} alt="" className="w-full h-24 object-cover" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ===== Code Playground =====
function CodeTab({ lang }) {
  const t = T[lang];
  const [code, setCode] = useState(`// ENGEREK code playground\nfunction greet(name) {\n  return \`Merhaba, \${name}!\`;\n}\nconsole.log(greet("Operator"));\n`);
  const [output, setOutput] = useState("");
  const run = () => {
    const logs = [];
    const oc = console.log;
    console.log = (...a) => logs.push(a.map((x) => typeof x === "object" ? JSON.stringify(x) : String(x)).join(" "));
    try {
      // eslint-disable-next-line no-new-func
      const r = new Function(code)();
      if (r !== undefined) logs.push("=> " + String(r));
    } catch (e) { logs.push("ERROR: " + e.message); }
    console.log = oc;
    setOutput(logs.join("\n"));
  };
  return (
    <div className="p-4 grid lg:grid-cols-2 gap-4 h-full">
      <div className="hud p-4 flex flex-col">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400 mb-2">// EDITOR // JS</div>
        <textarea className="input-hud font-mono-hud flex-1 resize-none text-sm" value={code} onChange={(e) => setCode(e.target.value)} data-testid="code-editor" />
        <button className="btn-hud mt-2 flex items-center justify-center gap-2" onClick={run} data-testid="code-run-btn">
          <Play size={14} /> RUN
        </button>
      </div>
      <div className="hud p-4 flex flex-col">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400 mb-2">// OUTPUT</div>
        <pre className="font-mono-hud text-sm text-red-100 whitespace-pre-wrap flex-1 overflow-auto bg-black/60 p-3 border border-red-900/30" data-testid="code-output">
          {output || "// awaiting execution //"}
        </pre>
      </div>
    </div>
  );
}

// ===== Calendar =====
function CalendarTab({ lang }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const i = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(i); }, []);
  const year = now.getFullYear(), month = now.getMonth();
  const first = new Date(year, month, 1);
  const startWeekday = (first.getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  const monthName = now.toLocaleString(lang, { month: "long", year: "numeric" });
  return (
    <div className="p-4 grid lg:grid-cols-3 gap-4 h-full">
      <div className="hud p-6 flex flex-col items-center justify-center text-center">
        <div className="font-orbitron text-[10px] tracking-[0.4em] text-red-400 mb-3">// TEMPORAL CORE</div>
        <div className="font-orbitron text-6xl font-black text-white tabular-nums" data-testid="clock-big">
          {now.toLocaleTimeString([], { hour12: false })}
        </div>
        <div className="font-rajdhani text-xl text-red-300 mt-4 tracking-widest uppercase">
          {now.toLocaleDateString(lang, { weekday: "long", day: "numeric", month: "long" })}
        </div>
        <div className="font-mono-hud text-red-400/70 text-xs mt-2">TZ: {Intl.DateTimeFormat().resolvedOptions().timeZone}</div>
      </div>
      <div className="lg:col-span-2 hud p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// {monthName.toUpperCase()}</div>
        </div>
        <div className="grid grid-cols-7 gap-1 text-center font-rajdhani text-red-300/70 text-xs mb-1">
          {["MON","TUE","WED","THU","FRI","SAT","SUN"].map(d => <div key={d}>{d}</div>)}
        </div>
        <div className="grid grid-cols-7 gap-1" data-testid="calendar-grid">
          {cells.map((d, i) => (
            <div key={i} className={`aspect-square border p-1 text-sm font-mono-hud ${
              d === now.getDate() ? "border-red-500 bg-red-900/30 text-white" :
              d ? "border-red-900/30 text-red-200/80" : "border-transparent"
            }`}>{d || ""}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ===== Voice Packs =====
function VoiceTab({ lang, voice, setVoice, ttsEnabled, setTtsEnabled }) {
  const t = T[lang];
  const [testing, setTesting] = useState("");
  const testVoice = async (v) => {
    setTesting(v);
    try {
      const map = { tr: "Merhaba, ben ENGEREK.", en: "Hello, I am ENGEREK.", ru: "Привет, я ENGEREK.", uk: "Привіт, я ENGEREK." };
      const r = await axios.post(`${API}/voice/tts`, { text: map[lang] || map.en, voice: v }, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = new Audio(url); a.onended = () => setTesting(""); a.onerror = () => setTesting(""); await a.play();
    } catch (e) { setTesting(""); toast.error(e.message); }
  };
  return (
    <div className="p-4 h-full overflow-y-auto">
      <div className="hud p-4 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// {t.voicePacks}</div>
            <div className="text-red-200/70 text-sm mt-1">Auto TTS: {ttsEnabled ? "ON" : "OFF"}</div>
          </div>
          <button className="btn-hud flex items-center gap-2" onClick={() => setTtsEnabled((v) => !v)} data-testid="toggle-tts">
            {ttsEnabled ? <Volume2 size={14}/> : <VolumeX size={14}/>}
            {ttsEnabled ? "ON" : "OFF"}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {VOICES.map((v) => (
          <div key={v} className={`hud p-4 cursor-pointer transition-colors duration-200 ${voice===v?"border-red-500 bg-red-900/20":""}`} onClick={() => setVoice(v)} data-testid={`voice-${v}`}>
            <div className="font-orbitron text-lg text-white uppercase tracking-widest">{v}</div>
            <div className="text-xs font-mono-hud text-red-400/80 mb-3">OpenAI · tts-1</div>
            <button className="btn-ghost w-full text-xs flex items-center justify-center gap-1" onClick={(e) => { e.stopPropagation(); testVoice(v); }} data-testid={`voice-test-${v}`}>
              {testing===v ? <Loader2 size={12} className="animate-spin"/> : <Play size={12}/>} {t.testVoice}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ===== Studio (Visual Studio-like workbench) =====
function StudioTab({ lang }) {
  const t = T[lang];
  const [templates, setTemplates] = useState([]);
  const [projects, setProjects] = useState([]);
  const [current, setCurrent] = useState(null);
  const [openFile, setOpenFile] = useState(null);
  const [editorValue, setEditorValue] = useState("");
  const [newName, setNewName] = useState("");
  const [newTpl, setNewTpl] = useState("dotnet-console");
  const [busy, setBusy] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);
  const [diag, setDiag] = useState(null);

  const loadTemplates = () => axios.get(`${API}/studio/templates`).then((r) => setTemplates(r.data));
  const loadProjects = () => axios.get(`${API}/studio/projects`).then((r) => setProjects(r.data));
  useEffect(() => { loadTemplates(); loadProjects(); }, []);

  const openProject = (p) => {
    setCurrent(p);
    const first = Object.keys(p.files)[0];
    setOpenFile(first);
    setEditorValue(p.files[first] || "");
    setDiag(null);
  };

  const openFileTab = (f) => {
    if (!current) return;
    setOpenFile(f);
    setEditorValue(current.files[f] || "");
    setDiag(null);
  };

  const create = async () => {
    if (!newName.trim()) { toast.error("Project name required"); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/studio/projects`, { name: newName, template: newTpl });
      await loadProjects();
      openProject(r.data);
      setNewName("");
      toast.success(`Project "${r.data.name}" created`);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const saveFile = async () => {
    if (!current || !openFile) return;
    const files = { ...current.files, [openFile]: editorValue };
    setCurrent({ ...current, files });
    await axios.put(`${API}/studio/projects/${current.id}/files`, { [openFile]: editorValue });
    toast.success("Saved");
  };

  const analyze = async (applyFix) => {
    if (!current || !openFile) return;
    setAnalyzing(true); setDiag(null);
    try {
      const langHint = (openFile.endsWith(".cs") ? "csharp" :
        openFile.endsWith(".py") ? "python" :
        openFile.endsWith(".jsx") || openFile.endsWith(".js") ? "javascript" :
        openFile.endsWith(".ts") || openFile.endsWith(".tsx") ? "typescript" : "");
      const r = await axios.post(`${API}/studio/analyze`, {
        filename: openFile, code: editorValue, language: langHint,
        project_id: current.id, apply_fix: !!applyFix,
      });
      setDiag(r.data);
      if (applyFix && r.data.fixed_code) {
        setEditorValue(r.data.fixed_code);
        const files = { ...current.files, [openFile]: r.data.fixed_code };
        setCurrent({ ...current, files });
        toast.success("Auto-fixed & saved");
      } else {
        toast.success(`${r.data.diagnostics.length} issue(s) detected`);
      }
    } catch (e) { toast.error(e.message); } finally { setAnalyzing(false); }
  };

  const downloadZip = () => {
    if (!current) return;
    window.open(`${API}/studio/projects/${current.id}/download`, "_blank");
  };

  const removeProject = async (id) => {
    await axios.delete(`${API}/studio/projects/${id}`);
    if (current?.id === id) { setCurrent(null); setOpenFile(null); setEditorValue(""); }
    loadProjects();
  };

  const sevColor = (s) => s === "error" ? "text-red-400" : s === "warning" ? "text-yellow-400" : "text-red-200";

  return (
    <div className="p-4 h-full grid grid-cols-12 gap-4 overflow-hidden">
      {/* Left: New project + project list */}
      <div className="col-span-3 flex flex-col gap-3 overflow-hidden">
        <div className="hud p-4 space-y-2">
          <div className="font-orbitron text-sm tracking-[0.3em] text-red-400">// {t.newProject}</div>
          <input className="input-hud w-full" placeholder={t.projectName} value={newName}
            onChange={(e) => setNewName(e.target.value)} data-testid="studio-new-name" />
          <select className="input-hud w-full" value={newTpl}
            onChange={(e) => setNewTpl(e.target.value)} data-testid="studio-template-select">
            {templates.map((tp) => <option key={tp.id} value={tp.id}>{tp.name}</option>)}
          </select>
          <button className="btn-hud w-full flex items-center justify-center gap-2" onClick={create} disabled={busy} data-testid="studio-create-btn">
            {busy ? <Loader2 size={14} className="animate-spin"/> : <FolderPlus size={14}/>} {t.createProject}
          </button>
        </div>
        <div className="hud p-3 flex-1 overflow-y-auto">
          <div className="font-orbitron text-[10px] tracking-[0.3em] text-red-400 mb-2">// PROJECTS</div>
          <div className="space-y-1" data-testid="studio-project-list">
            {projects.length === 0 && <div className="text-red-300/50 text-xs">// none yet //</div>}
            {projects.map((p) => (
              <div key={p.id}
                className={`p-2 border cursor-pointer flex items-center justify-between gap-2 transition-colors duration-200 ${
                  current?.id === p.id ? "border-red-500 bg-red-900/20" : "border-red-900/30 hover:bg-red-900/10"
                }`}>
                <div onClick={() => openProject(p)} className="flex-1 min-w-0" data-testid={`studio-open-${p.id}`}>
                  <div className="font-rajdhani text-white truncate">{p.name}</div>
                  <div className="text-[10px] font-mono-hud text-red-400/70 uppercase">{p.template}</div>
                </div>
                <button className="btn-ghost text-[10px] p-1" onClick={() => removeProject(p.id)} data-testid={`studio-del-${p.id}`}>
                  <Trash2 size={11}/>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Middle: File tree + editor */}
      <div className="col-span-6 flex flex-col hud overflow-hidden">
        {current ? (
          <>
            <div className="px-3 py-2 border-b border-red-900/40 flex items-center justify-between">
              <div className="flex items-center gap-2 min-w-0">
                <FolderOpen size={14} className="text-red-400"/>
                <span className="font-orbitron text-sm text-white truncate">{current.name}</span>
                <span className="text-[10px] font-mono-hud text-red-400/70 uppercase truncate">{current.template}</span>
              </div>
              <div className="flex items-center gap-1">
                <button className="btn-ghost flex items-center gap-1 text-[10px]" onClick={saveFile} data-testid="studio-save-btn">
                  <CheckCircle2 size={11}/> {t.saveFile}
                </button>
                <button className="btn-ghost flex items-center gap-1 text-[10px]" onClick={downloadZip} data-testid="studio-download-btn">
                  <Package size={11}/> {t.downloadZip}
                </button>
              </div>
            </div>
            <div className="flex flex-1 overflow-hidden">
              <div className="w-52 border-r border-red-900/30 overflow-y-auto p-2 space-y-0.5" data-testid="studio-file-tree">
                {Object.keys(current.files).sort().map((f) => (
                  <div key={f} onClick={() => openFileTab(f)}
                    className={`px-2 py-1 text-xs font-mono-hud cursor-pointer flex items-center gap-1 transition-colors duration-200 ${
                      openFile === f ? "bg-red-800/40 text-white" : "text-red-200/80 hover:bg-red-900/20"
                    }`}
                    data-testid={`studio-file-${f}`}
                    title={f}>
                    <FileIcon size={10}/> <span className="truncate">{f}</span>
                  </div>
                ))}
              </div>
              <div className="flex-1 flex flex-col">
                {openFile ? (
                  <>
                    <div className="px-3 py-1 border-b border-red-900/30 font-mono-hud text-[11px] text-red-300/80">
                      {openFile}
                    </div>
                    <textarea
                      value={editorValue}
                      onChange={(e) => setEditorValue(e.target.value)}
                      className="flex-1 bg-black/70 text-red-100 font-mono-hud text-xs p-3 resize-none border-0 focus:outline-none"
                      spellCheck={false}
                      data-testid="studio-editor"
                    />
                  </>
                ) : (
                  <div className="flex-1 flex items-center justify-center text-red-300/50 text-sm">// Pick a file //</div>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center text-red-300/50 text-sm p-8 text-center" data-testid="studio-empty">
            {t.noProject}
          </div>
        )}
      </div>

      {/* Right: Diagnostics panel */}
      <div className="col-span-3 hud p-3 overflow-y-auto flex flex-col">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400 mb-2">// AI DIAGNOSTICS</div>
        <div className="flex gap-1 mb-2">
          <button className="btn-hud flex-1 flex items-center justify-center gap-1 text-[10px]" onClick={() => analyze(false)} disabled={!current || !openFile || analyzing} data-testid="studio-analyze-btn">
            {analyzing ? <Loader2 size={12} className="animate-spin"/> : <Bug size={12}/>} {t.analyzeFix}
          </button>
          <button className="btn-hud flex-1 flex items-center justify-center gap-1 text-[10px]" onClick={() => analyze(true)} disabled={!current || !openFile || analyzing} data-testid="studio-autofix-btn">
            <Wand2 size={12}/> {t.autoFix}
          </button>
        </div>
        <div className="flex-1 space-y-2 overflow-y-auto" data-testid="studio-diagnostics">
          {!diag && <div className="text-red-300/50 text-xs">// no scan yet //</div>}
          {diag && diag.summary && (
            <div className="text-xs font-mono-hud text-red-200/90 border border-red-900/30 p-2">
              {diag.summary}
            </div>
          )}
          {diag && diag.diagnostics.length === 0 && (
            <div className="flex items-center gap-2 text-green-400 text-xs font-mono-hud">
              <CheckCircle2 size={12}/> {t.allClean}
            </div>
          )}
          {diag && diag.diagnostics.map((d, i) => (
            <div key={i} className="border border-red-900/30 p-2 text-xs" data-testid={`studio-diag-${i}`}>
              <div className={`flex items-center gap-1 font-mono-hud uppercase tracking-wider ${sevColor(d.severity)}`}>
                <AlertTriangle size={11}/> {d.severity} · L{d.line ?? "?"}
                {d.code && <span className="opacity-60 ml-1">[{d.code}]</span>}
              </div>
              <div className="text-red-100 mt-1">{d.message}</div>
              {d.suggestion && <div className="text-red-300/80 mt-1 italic">→ {d.suggestion}</div>}
            </div>
          ))}
        </div>
        {current && (
          <div className="mt-2 pt-2 border-t border-red-900/30 text-[10px] font-mono-hud text-red-400/70">
            <div>{templates.find(x => x.id === current.template)?.ide_hint}</div>
          </div>
        )}
      </div>
    </div>
  );
}

// ===== Settings =====
function SettingsTab({ lang }) {
  return (
    <div className="p-4 h-full">
      <div className="hud p-6 max-w-2xl">
        <div className="font-orbitron text-sm tracking-[0.3em] text-red-400 mb-3">// SYSTEM DIAGNOSTICS</div>
        <div className="space-y-2 font-mono-hud text-sm text-red-200/90">
          <div>MODEL // <span className="text-white">Claude Sonnet 4.6</span></div>
          <div>IMAGE ENGINE // <span className="text-white">Gemini Nano Banana</span></div>
          <div>STT // <span className="text-white">Whisper-1</span></div>
          <div>TTS // <span className="text-white">OpenAI tts-1</span></div>
          <div>LANG // <span className="text-white uppercase">{lang}</span></div>
          <div>BUILD // <span className="text-white">ENGEREK.AL v1.0.0</span></div>
        </div>
        <div className="mt-4 border-t border-red-900/30 pt-4 text-xs text-red-300/70">
          ENGEREK AL — Jarvis-style tactical assistant. Voice + text, multilingual (TR/EN/RU/UK),
          code, plans, reports, image generation & editing, task ops.
        </div>
      </div>
    </div>
  );
}

// ===== Main App =====
function App() {
  const [lang, setLang] = useState(localStorage.getItem("engerek-lang") || "tr");
  const [tab, setTab] = useState("assistant");
  const [voice, setVoice] = useState(localStorage.getItem("engerek-voice") || "onyx");
  const [ttsEnabled, setTtsEnabled] = useState(localStorage.getItem("engerek-tts") !== "false");
  const [orbState, setOrbState] = useState("idle");
  const [connected, setConnected] = useState(false);

  useEffect(() => { localStorage.setItem("engerek-lang", lang); }, [lang]);
  useEffect(() => { localStorage.setItem("engerek-voice", voice); }, [voice]);
  useEffect(() => { localStorage.setItem("engerek-tts", String(ttsEnabled)); }, [ttsEnabled]);

  useEffect(() => {
    axios.get(`${API}/`).then(() => setConnected(true)).catch(() => setConnected(false));
  }, []);

  return (
    <div className="h-screen w-screen overflow-hidden flex flex-col grid-bg" data-testid="engerek-app">
      <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#140808", color: "#fff", border: "1px solid #8a0000" } }} />
      <TopBar lang={lang} setLang={setLang} connected={connected} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar tab={tab} setTab={setTab} lang={lang} />
        <main className="flex-1 overflow-hidden relative scanlines">
          {tab === "assistant" && <AssistantTab lang={lang} voice={voice} ttsEnabled={ttsEnabled} setOrbState={setOrbState} />}
          {tab === "tasks" && <TasksTab lang={lang} />}
          {tab === "reports" && <ReportsTab lang={lang} />}
          {tab === "image" && <ImageTab lang={lang} />}
          {tab === "code" && <CodeTab lang={lang} />}
          {tab === "studio" && <StudioTab lang={lang} />}
          {tab === "calendar" && <CalendarTab lang={lang} />}
          {tab === "voice" && <VoiceTab lang={lang} voice={voice} setVoice={setVoice} ttsEnabled={ttsEnabled} setTtsEnabled={setTtsEnabled} />}
          {tab === "settings" && <SettingsTab lang={lang} />}
        </main>
      </div>
      <div className="hud px-4 py-1 text-[10px] font-mono-hud text-red-400/70 flex items-center justify-between border-t border-red-900/40">
        <span>ENGEREK.AL // {T[lang].status}</span>
        <span>ORB: {orbState.toUpperCase()} · VOICE: {voice.toUpperCase()} · LANG: {lang.toUpperCase()}</span>
      </div>
    </div>
  );
}

export default App;
